// Central per-route SEO: title, meta description and keywords for every static
// route on the site. Consumed by <Seo /> as a fallback when a page doesn't pass
// explicit props (detail pages pass their own). Keeps meta rich & unique so the
// site is fully indexable by search engines and AI crawlers.
export const PAGE_SEO = {
  "/": {
    title: "Dharmartha · धर्मार्थ — Knowledge Traditions of Bharat",
    description:
      "Dharmartha (धर्मार्थ) — a calm, editorial digital gateway to the knowledge traditions of Bharat. Kathas, mantras, suktas, pooja vidhi, stotras, deities, temples, festivals and a live Panchangam, organised and explained with authentic sources.",
    keywords:
      "Dharmartha, Sanatana Dharma, Hindu scriptures, Vedas, Upanishads, Puranas, kathas, mantras, stotras, pooja vidhi, panchanga, temples of Bharat, deities, festivals, Bharatiya knowledge",
  },
  "/explore": {
    title: "Explore — Kathas, Mantras, Stotras, Pooja Vidhi & More",
    description:
      "Browse the full library of Dharmartha — kathas, mantras, suktas, stotras, pooja vidhi, festivals, deities and temples of Bharat, each with Devanagari text, transliteration, meaning and sources.",
    keywords: "explore Hindu knowledge, kathas, mantras, stotras, suktas, pooja vidhi, festivals, deities, temples",
  },
  "/kathas": {
    title: "Kathas — Sacred Stories & Narratives of Bharat",
    description:
      "Read kathas — the sacred stories and narratives of India's spiritual and scriptural traditions, retold faithfully with sources, chapters and context.",
    keywords: "kathas, Hindu stories, Puranic tales, vrat katha, Ramayana, Mahabharata stories, pauranik katha",
  },
  "/mantras": {
    title: "Mantras — Devanagari, Transliteration, Meaning & Audio",
    description:
      "Mantras with authentic Devanagari text, IAST transliteration, pronunciation guidance, word meaning and scriptural context — for daily sadhana and study.",
    keywords: "mantras, Sanskrit mantras, Gayatri mantra, bija mantra, mantra meaning, mantra transliteration, japa",
  },
  "/suktas": {
    title: "Suktas & Vedic Knowledge — Hymns with Meaning",
    description:
      "Vedic suktas (hymns) and Vedic knowledge in full — Devanagari text, transliteration and meaning, with the Vedic source for each hymn.",
    keywords: "suktas, Vedic hymns, Rig Veda, Purusha Sukta, Sri Sukta, Vedic knowledge, Vedas",
  },
  "/stotras": {
    title: "Stotras — Devotional Hymns with Text & Meaning",
    description:
      "Stotras — devotional hymns to the deities, with Devanagari text, transliteration, meaning and context, drawn from authentic scriptural sources.",
    keywords: "stotras, stotra, devotional hymns, Vishnu Sahasranama, Lalita Sahasranama, Shiva stotra, ashtakam",
  },
  "/rituals": {
    title: "Rituals & Pooja Guides — Step-by-Step Worship",
    description:
      "Clear, step-by-step pooja vidhi — how commonly performed poojas, rituals and observances are done, with sankalpa, materials, steps and mantras.",
    keywords: "pooja vidhi, pooja vidhi, pooja method, aarti, vrat vidhi, ritual guide, ganesh pooja, satyanarayan pooja",
  },
  "/festivals": {
    title: "Festivals & Observances of Sanatana Dharma",
    description:
      "Festivals, vratas and observances of the Hindu calendar — their significance, dates, rituals and the stories behind them.",
    keywords: "Hindu festivals, vrata, Diwali, Navratri, Ganesh Chaturthi, Janmashtami, tyohar, observances",
  },
  "/scriptures": {
    title: "Scriptures — Vedas, Upanishads, Puranas & Itihasa",
    description:
      "An organised guide to the scriptures of Bharat — Vedas, Upanishads, Puranas, Itihasa and Darshanas — with summaries and sources.",
    keywords: "Hindu scriptures, Vedas, Upanishads, Puranas, Bhagavad Gita, Itihasa, shastra",
  },
  "/rishis": {
    title: "Rishis & Seers of the Sanatana Tradition",
    description:
      "The rishis and seers of the Sanatana tradition — the sages behind the mantras, scriptures and lineages of Bharat.",
    keywords: "rishis, sages, saptarishi, Vedic seers, munis, acharyas",
  },
  "/philosophy": {
    title: "Philosophy — Darshanas & Core Concepts of Dharma",
    description:
      "Core concepts and philosophy (darshana) of Sanatana Dharma — dharma, karma, moksha, atman, the six darshanas and more, explained clearly.",
    keywords: "Hindu philosophy, darshana, Vedanta, dharma, karma, moksha, atman, Advaita",
  },
  "/pilgrimage": {
    title: "Pilgrimage — Tirthas & Sacred Journeys of Bharat",
    description:
      "The tirthas and sacred pilgrimage journeys of Bharat — the holy sites, their significance and the traditions of yatra.",
    keywords: "pilgrimage, tirtha, yatra, Char Dham, Kashi, Kedarnath, sacred sites",
  },
  "/samskaras": {
    title: "Samskaras — The Sacred Rites of Life",
    description:
      "The samskaras — the sacred rites of passage that mark the stages of life in the Sanatana tradition, with meaning and method.",
    keywords: "samskaras, sanskar, rites of passage, upanayana, vivaha, naming ceremony, Hindu rituals",
  },
  "/sanskrit": {
    title: "Sanskrit — The Language of the Scriptures",
    description:
      "An introduction to Sanskrit — the sacred language of the Vedas and scriptures — its script, sounds and the key terms used across Dharmartha.",
    keywords: "Sanskrit, Devanagari, Sanskrit learning, Vedic Sanskrit, shloka, language of the Vedas",
  },
  "/deities": {
    title: "Deities — The Devatas of Sanatana Dharma",
    description:
      "The devatas of Sanatana Dharma — their forms, epithets, iconography, associated mantras and the traditions of their worship.",
    keywords: "Hindu deities, devata, Vishnu, Shiva, Devi, Ganesha, Hanuman, gods and goddesses",
  },
  "/temples": {
    title: "Temples of Bharat — Jyotirlingas, Shakti Peethas & More",
    description:
      "The sacred temple circuits of Bharat — the Dwadash Jyotirlingas, 51 Shakti Peethas, Ashta Vinayaka, Pancha Bhoota Sthalams and great heritage temples, with location and significance.",
    keywords: "temples of Bharat, Jyotirlinga, Shakti Peetha, Ashta Vinayaka, Pancha Bhoota, Hindu temples, mandir",
  },
  "/panchang": {
    title: "Panchangam — Daily Tithi, Nakshatra, Muhurta & Choghadiya",
    description:
      "Live daily Panchangam — tithi, vara, nakshatra, yoga and karana for your location, with Rahu Kalam, Abhijit Muhurta, Choghadiya and the Hora timeline.",
    keywords: "panchanga, daily panchanga, tithi, nakshatra, muhurta, rahu kalam, choghadiya, hora, hindu calendar",
  },
  "/quiz": {
    title: "Dharma Quiz — Test Your Knowledge of the Tradition",
    description:
      "A gentle quiz on the kathas, deities, festivals and concepts of Sanatana Dharma — learn as you play.",
    keywords: "Hindu quiz, dharma quiz, mythology quiz, Sanatana Dharma trivia",
  },
  "/patrika": {
    title: "Patrika — Essays & Reflections on the Tradition",
    description:
      "The Dharmartha Patrika — essays, reflections and articles on the living knowledge traditions of Bharat.",
    keywords: "Hindu blog, dharma essays, spiritual articles, Patrika, Sanatana Dharma writing",
  },
  "/glossary": {
    title: "Glossary — Sanskrit & Dharmic Terms Explained",
    description:
      "A growing glossary of Sanskrit and dharmic terms — Devanagari, transliteration and clear meaning for every term used across Dharmartha.",
    keywords: "Sanskrit glossary, dharmic terms, Hindu terminology, Sanskrit meanings, shabdakosh",
  },
  "/services": {
    title: "Services — Pooja Booking, Astrology, Muhurta & Yagya",
    description:
      "Dharmartha services — book a pooja, request an astrology or numerology reading, find an auspicious muhurta or arrange a yagya, guided by tradition.",
    keywords: "pooja booking, astrology, numerology, muhurta, yagya, jyotish, online pooja",
  },
  "/calendar": {
    title: "Festival Calendar — Upcoming Vratas & Observances",
    description:
      "The Dharmartha festival calendar — upcoming festivals, vratas and observances with dates and significance.",
    keywords: "Hindu calendar, festival calendar, vrat dates, tithi calendar, upcoming festivals",
  },
  "/japa": {
    title: "Japa — Track Your Mantra Practice",
    description:
      "A simple japa counter to track your mantra practice and daily sadhana on Dharmartha.",
    keywords: "japa, mantra counter, mala, sadhana tracker, chanting",
  },
  "/leaderboard": {
    title: "Leaderboard — The Dharmartha Community",
    description: "See the Dharmartha community's reading and sadhana progress on the leaderboard.",
    keywords: "leaderboard, community, reading progress, sadhana",
  },
  "/invite": {
    title: "Invite Friends to Dharmartha",
    description: "Share Dharmartha with friends and family and invite them to explore the knowledge traditions of Bharat.",
    keywords: "invite, refer, share Dharmartha",
  },
  "/ganesh-chaturthi": {
    title: "Ganesh Chaturthi — Pooja Vidhi, Mantras, Stotras & Katha",
    description:
      "A complete Ganesh Chaturthi guide — home sthapana and pooja vidhi, mantras, stotras, the katha of Ganesha and the significance of the festival.",
    keywords: "Ganesh Chaturthi, Ganesha pooja vidhi, Ganpati mantra, Ganesh stotra, Vinayaka Chaturthi",
  },
  "/live-darshan": {
    title: "Live Darshan — Sacred Temples of Bharat",
    description: "Watch live darshan from the sacred temples of Bharat on Dharmartha.",
    keywords: "live darshan, temple live, online darshan, mandir live",
  },
  "/numerology": {
    title: "Numerology Calculator — Your Numbers by Birth Details",
    description: "A free numerology calculator — discover your core numbers from your name and date of birth.",
    keywords: "numerology, numerology calculator, life path number, ank jyotish, birth numbers",
  },
  "/about": {
    title: "About Dharmartha",
    description:
      "About Dharmartha — a bootstrapped community initiative building a respectful, well-sourced digital home for the knowledge traditions of Bharat.",
    keywords: "about Dharmartha, mission, Sanatana Dharma website, Hindu knowledge platform",
  },
  "/contact": {
    title: "Contact Dharmartha",
    description: "Get in touch with the Dharmartha team — questions, corrections, contributions and collaborations are welcome.",
    keywords: "contact Dharmartha, feedback, contribute, corrections",
  },
  "/support": {
    title: "Support Dharmartha",
    description: "Support Dharmartha — help us keep building a free, well-sourced home for the knowledge traditions of Bharat.",
    keywords: "support Dharmartha, donate, contribute, seva",
  },
  "/search": {
    title: "Search Dharmartha",
    description: "Search across all of Dharmartha — kathas, mantras, stotras, suktas, pooja vidhi, deities, temples and the glossary.",
    keywords: "search, find mantra, find katha, find temple, find stotra",
  },
  "/bookmarks": {
    title: "Your Bookmarks — Dharmartha",
    description: "Your saved kathas, mantras, stotras and knowledge on Dharmartha.",
    keywords: "bookmarks, saved, reading list",
  },
};
